module.exports = __webpack_public_path__ + "static/img/1075.14a9b13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1075.jpg
// module id = 257
// module chunks = 0